import { ca } from '@cian/analytics';

import { CAROUSEL_PLACE } from '../../../../constants';

export function trackParentClick({
  realtyUserId,
  position,
  parentId,
  title,
  parentUrl,
}: {
  realtyUserId: number;
  position: number;
  parentId: number | undefined;
  title: string;
  parentUrl: string | undefined;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_cardjk',
    page: {
      extra: {
        is_specproject: true,
        to_object: parentId,
        object_type: 'JK',
        position: position + 1,
        hit_url: parentUrl,
        carousel_name: title,
        carousel_place: CAROUSEL_PLACE,
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
